export default __webpack_public_path__ + "maps-examples-multiple-images-thumbnail-480-ada417fd85d11e3c3344aa086ac26d95.webp";